<template>
    <div>
        <h1 class="display-heading">Consultation Session</h1>

        <ul class="nav nav-tabs nav-tabs-nowrap" id="myTab" role="tablist">
            <li class="nav-item">
                <a
                    class="nav-link active"
                    id="consultation-details-tab"
                    data-toggle="tab"
                    href="#consultationDetails"
                    role="tab"
                >Consultation Details</a>
            </li>
        </ul>

        <div class="tab-content" id="myTabContent">
            <div class="tab-pane fade show active" id="consultationDetails" role="tabpanel">
                <div class="tab-content-wrapper">
                    <div class="card mb-5">
                        <div class="card-body">
                            <appointment-detail
                                participantNameDisplay="Doctor Name"
                                :isConsultation="true"
                                :consultationId="consultation.consultationId"
                                :appointmentDate="consultation.startTime"
                                :appointmentParticipant="consultation.doctorName"
                                :doctorClinicHospitalName="consultation.doctorHospitalOrClinic"
                                :isPatient="true"
                            ></appointment-detail>
                        </div>
                    </div>

                    <div>
                        <div class="card mb-5">
                            <div class="card-body">

                                <div class="mb-5">
                                    <h5 class="mb-3">Medication Details</h5>
                                    <div>
                                        <prescription-detail
                                            :isEdit="false"
                                            v-model="prescriptionList"
                                            :drugType="2"
                                        ></prescription-detail>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="mb-5">
                            <h5 class="mb-3">Consultation Details</h5>
                            <div>
                                <label>Doctor Advice</label>
                                <div class="card">
                                    <div class="card-body">
                                        <div v-html="doctorAdvice"></div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import popupModal from '@/components/popup-modal';
import {
    replaceLineBreakInHtml,
    constructPrescriptionList
} from '@/utilities';
import appointmentDetail from '@/components/appointment-detail';
import prescriptionDetail from '@/components/prescription';
import twilioVideo from '@/components/twilio-video';
import doctorConsultationPrice from '@/components/doctor-consultation-price';
export default {
    'components': {
        appointmentDetail,
        prescriptionDetail,
        twilioVideo,
        doctorConsultationPrice,
        popupModal
    },
    'computed': {
        isCompanyUser () {
            return this.$store.state.user.isCompanyUser;
        },
        consultationId () {
            return this.$route.params.id;
        },
        doctorAdvice () {
            return this.consultation.advice ? replaceLineBreakInHtml(this.consultation.advice) : 'NIL';
        }
    },
    data () {
        return {
            'form': {
                'da': null,
                'ea': null,
                'la': null,
                'm': null,
                'ai': null,
                'c': null
            },
            'consultation': {
                'startTime': null,
                'consultationId': null,
                'participantName': null,
                'participantIcNumber': null,
                'doctorName': null,
                'advice': null,
                'type': 0,
                'doctorHospitalOrClinic': ''
            },
            'prescriptionList': []
        };
    },
    mounted () {
        let id = this.$route.params.id;

        if (id) {
            this.axios
                .get('Clinic/GetPatientConsultationDetail', {
                    'params': {
                        'consultationId': id
                    }
                })
                .then(({ data }) => {
                    // console.log(data);
                    let consultation = data.data;

                    this.consultation.startTime = consultation.st;
                    this.consultation.consultationId = consultation.cis;
                    this.consultation.advice = consultation.a;
                    this.consultation.doctorName = consultation.dn
                        ? consultation.dn
                        : null;
                    this.consultation.doctorHospitalOrClinic = consultation.cn
                        ? consultation.cn
                        : null;

                    if (consultation.p && consultation.p.pil) {
                        this.prescriptionList = constructPrescriptionList(consultation.p.pil);
                    }
                })
                .catch(() => {});
        }
    }
};
</script>

<style>
</style>
